import { Box } from "@mui/material";
import React from "react";


export default function AllergenIcon({source}: {source: string}) {
    return <Box component={"img"} src={source} style={{ width: "28px", height: "28px", borderRadius: "50%", marginRight: "5px"}}></Box>
}

